import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { RoleFilterSchema } from '../RoleSchema';
import { RoleListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'ROLE';

export function RoleFiltering(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Role");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [roleFilteringData, setRoleFilteringData] = useState([]);
    const [roleFiltering, setRoleFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',

    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(RoleFilterSchema).options({ allowUnknown: true });

    useEffect(() => {
trackPromise(
        getGroupsForDropdown()
)
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
            )
    }, [roleFiltering.groupID]);

    useEffect(() => {
        setRoleFilteringData([]);
        handleSearch();
    }, [roleFiltering.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWROLELISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITROLE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setRoleFiltering({
            ...roleFiltering,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await services.getAllOperationEntitiesForDropDown(roleFiltering.groupID);
        setOperationEntity(operationEntities);
    }

    function validateInputs(target){
        const error = { ...errors }
        const errorMessage = validateProperty(target, RoleFilterSchema)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setErrors(error);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setRoleFiltering({
            ...roleFiltering,
            groupID: target.value,
            operationEntityID: "0"
        });
    }

    function handleOperationEntityChange(target){
        validateInputs(target);

        setRoleFiltering({
            ...roleFiltering,
            operationEntityID: target.value
        });
    }

    async function handleSearch(e) {

        if (e !== undefined) {
            const errorMessages = validate(schema, roleFiltering);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        if(roleFiltering.groupID != 0 && roleFiltering.operationEntityID != 0){
            const response = await services.getRoleFilteringData(roleFiltering);
            setRoleFilteringData(response);
        }
    }

    async function editRoleFiltering(data) {
        props.history.push({
            pathname: 'role/AddEdit',
            data: data,
            edit: true
        });
    }
    async function editRolePermissions(data) {
        props.history.push({
            pathname: 'rolepermissions',
            data: data,
            edit: true
        });
    }

    function clearState() {
        setRoleFiltering({
            ...roleFiltering,
            groupID: '0',
            operationEntityID: '0',
        });
        setRoleFilteringData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="role/AddEdit"
                                    buttonText="Add Role"
                                />
                            </div>
                            <hr />
                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={roleFiltering.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={roleFiltering.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <RoleListing 
                                    roleFilteringData={roleFilteringData} 
                                    handleClick={editRoleFiltering} 
                                    handleChange={editRolePermissions} 
                                    editEnabled={permissionList.isAddEditEnabled}
                                />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}